var r = Array.isArray, a = r;
export {
  a as i
};
